import { useRouter } from 'next/router';
import {
  Bar,
  ComposedChart,
  LabelList,
  Line,
  ResponsiveContainer,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const ApplicationsMonthly: React.FC = () => {
  const { locale } = useRouter();

  const GRAPH_10_MONTHLY_APPLICATIONS = [
    { label: locale === 'es' ? 'Ene' : 'Jan', value: 5 },
    { label: 'Feb', value: 5 },
    { label: 'Mar', value: 9 },
    { label: locale === 'es' ? 'Abr' : 'Apr', value: 7 },
    { label: 'May', value: 8 },
    { label: 'Jun', value: 7 },
    { label: 'Jul', value: 7 },
    { label: locale === 'es' ? 'Ago' : 'Aug', value: 6 },
    { label: 'Sep', value: 9 },
    { label: 'Oct', value: 13 },
    { label: 'Nov', value: 12 },
    { label: locale === 'es' ? 'Dic' : 'Dec', value: 12 }
  ];

  return (
    <div>
      <StyledRecharts className="applications">
        <ResponsiveContainer width="99%" height={140}>
          <ComposedChart data={GRAPH_10_MONTHLY_APPLICATIONS}>
            <XAxis
              type="category"
              allowDecimals={false}
              dataKey="label"
              interval={0}
              tickLine={false}
            />
            <YAxis type="number" hide={true} />

            <Bar
              dataKey="value"
              isAnimationActive={false}
              fill="#28CEBC"
              barSize={40}
            >
              <LabelList
                dataKey="value"
                formatter={(value: number) => [value + '%']}
                position="insideBottom"
              />
            </Bar>
            <Line
              dataKey="value"
              type="monotone"
              dot={false}
              stroke="#84F6D6"
              strokeWidth={2}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default ApplicationsMonthly;
